import { useQuery } from "@apollo/client";
import { GET_OUTPUT_FIELDS_METADATA } from "../api/queries";

export default function useOutputFieldMetadataQuery() {
    const query = useQuery(GET_OUTPUT_FIELDS_METADATA)

    return { ...query, data: (query.data && query.data.outputMetadata) ? query.data.outputMetadata : []}
}